"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'LotDetailBudAch',
  props: ['idLot'],
  data: function data() {
    return {
      multipleSelection: [],
      refresh: 0,
      lotsDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false,
      rowsForCanceling: [],
      rowsForSaving: [],
      // pour mémoriser uniquement les lignes modifiées et éviter de tout sauvegarder,
      // --
      CONST: CONST
    };
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    canEdit: function canEdit() {
      var cond1 = [CONST.AFFAIRE.STATUS.CREATED.value, CONST.AFFAIRE.STATUS.TOVALIDATE1.value, CONST.AFFAIRE.STATUS.VALIDATED1.value, CONST.AFFAIRE.STATUS.TOVALIDATE2.value, CONST.AFFAIRE.STATUS.VALIDATED2.value, CONST.AFFAIRE.STATUS.DENIED1.value, CONST.AFFAIRE.STATUS.DENIED2.value].includes(this.affaire.affaire.status) && CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value === this.affaire.affaire.etape;
      var cond2 = [CONST.AFFAIRE.STATUS.CREATED.value, CONST.AFFAIRE.STATUS.TOVALIDATE1.value, CONST.AFFAIRE.STATUS.VALIDATED1.value, CONST.AFFAIRE.STATUS.TOVALIDATE2.value, CONST.AFFAIRE.STATUS.VALIDATED2.value, CONST.AFFAIRE.STATUS.DENIED1.value, CONST.AFFAIRE.STATUS.DENIED2.value].includes(this.affaire.affaire.statusBudgetAffaire) && CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value === this.affaire.affaire.etape;
      return cond1 || cond2;
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    _eventBus.EventBus.$on('EDIT_LOT', function (idLot) {
      if (_this2.idLot === idLot) {
        _this2.modeEdit = true;
        _this2.rowsForCanceling = JSON.parse(JSON.stringify(_this2.lotsDetail));
        _this2.rowsForSaving = [];
        _this2.refresh++;

        _eventBus.EventBus.$emit('MODE_EDIT', true);
      }
    });

    _eventBus.EventBus.$on('REFRESH', function () {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE, CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE];
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('EDIT_LOT');

    _eventBus.EventBus.$off('REFRESH');
  },
  methods: {
    cellClass: function cellClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE && ['mtObjDebourseExec', 'mtMargeBrute', 'pcMargeBrute'].includes(column.property)) {
        return 'tb-pattern';
      }
    },
    // gestion de la sélection multiple colonne validation
    toggleSelection: function toggleSelection(checked) {
      var _this3 = this;

      if (checked) {
        this.$refs.dataTable.toggleAllSelection();
        this.lotsDetail.map(function (row, index) {
          if (Number(_this3.calculs[index].validation) !== 1) {
            row.validation = 2;
            row.date_validation = (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss');

            if (_this3.rowsForSaving.indexOf(row.id) === -1) {
              _this3.rowsForSaving.push(row.id);
            }
          }
        });
      } else {
        this.lotsDetail.map(function (row, index) {
          if (Number(_this3.calculs[index].validation) !== 1) {
            row.validation = 0;
            row.date_validation = null;

            if (_this3.rowsForSaving.indexOf(row.id) === -1) {
              _this3.rowsForSaving.push(row.id);
            }
          }
        });
        this.$refs.dataTable.clearSelection();
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // --------------------------------------------------
    handleAdd: function () {
      var _handleAdd = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var row;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                row = {
                  id_lot: this.idLot,
                  libelle: '',
                  prestataire: '',
                  mt_vente_initiale: null,
                  mt_proposition_prestataire: null,
                  type_lot_detail: CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE,
                  ordre: Math.max.apply(Math, _toConsumableArray(this.lotsDetail.map(function (o) {
                    return o.ordre;
                  })).concat([0])) + 1,
                  id_debourseIndirect: 0,
                  validation: 0
                };
                _context.next = 3;
                return this.$store.dispatch('affaire/insertLotDetail', row);

              case 3:
                _context.next = 5;
                return this.$store.dispatch('affaire/updateLotDetail', row);

              case 5:
                _context.next = 7;
                return this.$store.dispatch('affaire/setLotDetail', row);

              case 7:
                this.lotsDetail[this.lotsDetail.length] = row;
                this.rowsForSaving.push(row.id);
                this.modeEdit = true;

                _eventBus.EventBus.$emit('MODE_EDIT', true);

                _eventBus.EventBus.$emit('REFRESH_CALCULS');

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleAdd() {
        return _handleAdd.apply(this, arguments);
      }

      return handleAdd;
    }(),
    handleDelete: function handleDelete(scope) {
      var _this4 = this;

      var msg = 'Voulez-vous supprimer cette ligne ?';
      this.$confirm(msg, 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(function () {
        _this4.action('deleteLotDetail', scope.row);

        var index = _this4.rowsForSaving.findIndex(function (id) {
          return id === scope.row.id;
        });

        if (index > -1) {
          _this4.rowsForSaving.splice(index, 1);
        }
      });
    },
    handleInput: function handleInput(scope, action) {
      // ajout de la date de validation si le champ modifié est la case à cocher
      // si coché => date/heure courante
      // sinon => ''
      if (scope.column['property'] === 'validation') {
        scope.row['date_validation'] = scope.row['validation'] === 1 ? (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss') : null;
      } // mémorisation de la ligne modifiée pour ne sauvegarder + tard que celles concernées
      // et pas toutes les lignes de lotsDetail (on optimise le nombre de requete sql à faire)


      if (this.rowsForSaving.indexOf(scope.row.id) === -1) {
        this.rowsForSaving.push(scope.row.id);
      }

      this.$store.dispatch('affaire/setLotDetail', scope.row).then(function () {
        if (action === 'refresh_calcul') {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');
        }
      });
    },
    handleCancel: function handleCancel() {
      var _this5 = this;

      this.modeEdit = false;
      this.refresh++;
      var rows = this.rowsForCanceling;
      rows.forEach(function (row, index) {
        _this5.$store.dispatch('affaire/setLotDetail', row);
      });
      this.rowsForCanceling = [];
      this.rowsForSaving = [];

      _eventBus.EventBus.$emit('MODE_EDIT', false);

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    },
    handleSave: function () {
      var _handleSave = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this6 = this;

        var error, _loop, i;

        return _regenerator.default.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                error = false;
                _loop = /*#__PURE__*/_regenerator.default.mark(function _loop(i) {
                  var index, mt, isValid;
                  return _regenerator.default.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          index = _this6.lotsDetail.findIndex(function (row) {
                            return row.id === _this6.rowsForSaving[i];
                          });

                          if (!(index > -1)) {
                            _context2.next = 19;
                            break;
                          }

                          // pour éviter un bug si la zone de saisie est vide
                          mt = _this6.lotsDetail[index].mt_proposition_prestataire;
                          _this6.lotsDetail[index].mt_proposition_prestataire = mt === '' ? null : mt; // pour eviter un bug si on a ajouter/modifier un avenant au marché principal avant de passer par ici

                          delete _this6.lotsDetail[index].mt_avenant; // pour eviter un bug si on a ajouter/modifier un transfert avant de passer par ici

                          delete _this6.lotsDetail[index].mt_transfert; // pour eviter un bug lors de la mise à jour du lot detail si on vient précedemment de l'écran de gestion mensuelle

                          delete _this6.lotsDetail[index].pc_avancement_cumule;
                          delete _this6.lotsDetail[index].mt_facture; // mise à jour

                          _context2.next = 10;
                          return apiLotDetail.isValid(_this6.lotsDetail[index]);

                        case 10:
                          isValid = _context2.sent;

                          if (!isValid.error) {
                            _context2.next = 15;
                            break;
                          }

                          error = isValid.message;
                          _context2.next = 19;
                          break;

                        case 15:
                          _context2.next = 17;
                          return _this6.$store.dispatch('affaire/updateLotDetail', _this6.lotsDetail[index]);

                        case 17:
                          _context2.next = 19;
                          return _this6.$store.dispatch('affaire/setLotDetail', _this6.lotsDetail[index]);

                        case 19:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 3:
                if (!(i < this.rowsForSaving.length)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 5);

              case 5:
                i++;
                _context3.next = 3;
                break;

              case 8:
                if (error) {
                  this.$message.error(error);
                } else {
                  this.modeEdit = false;

                  _eventBus.EventBus.$emit('MODE_EDIT', false);

                  _eventBus.EventBus.$emit('REFRESH_CALCULS');

                  this.refresh++;
                }

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSave() {
        return _handleSave.apply(this, arguments);
      }

      return handleSave;
    }(),
    // -----------------------------------------------
    action: function () {
      var _action2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(_action, lotdetail) {
        var _this7 = this;

        return _regenerator.default.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // plus utilisé sauf dans handlDelete fonction qui n'esplus utilisé car bouton Delete masqué
                this.$store.dispatch('affaire/' + _action, lotdetail).then(function () {
                  _this7.$store.dispatch('affaire/setLotDetail', lotdetail).then(function () {
                    _eventBus.EventBus.$emit('REFRESH_CALCULS');
                  });
                }).catch(function (error) {
                  _this7.$message(error);
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function action(_x, _x2) {
        return _action2.apply(this, arguments);
      }

      return action;
    }()
  }
};
exports.default = _default;